import Component from '@glimmer/component';
import { t } from 'ember-intl';
import ReimaginedContributionHistory from 'tio-employee/components/reimagined/production/contribution-history';
import type { ReimaginedContributionHistoryModel } from 'tio-employee/components/reimagined/production/contribution-history';
import type PersonModel from 'tio-data/models/person';

interface SlrDashboardSignature {
  Args: {
    model: { person: PersonModel; reimagined: ReimaginedContributionHistoryModel };
  };
}

export default class SlrDashboardRouteComponent extends Component<SlrDashboardSignature> {
  get reimaginedModel() {
    return this.args.model.reimagined;
  }

  <template>
    <div class="flex flex-col gap-2">
      <h1 class="app-page-title px-4 pt-4">{{t "dashboard_tiles.student_loan_repayment"}}</h1>
      <ReimaginedContributionHistory @model={{this.reimaginedModel}} />
    </div>
  </template>
}
